export const messages = {
    'profilePage.title': 'My profile',
    'profileForm.email.label': 'Email',
    'profileForm.firstName.label': 'First name',
    'profileForm.lastName.label': 'Last name',
    'profileForm.error.email': 'Email shall contain \'@\', \'.\' and shall not contain space',
    'profileForm.error.required': (fieldLabel?: string) => `${fieldLabel} can't be blank`,
    'profileAvatar.title': 'Avatar',
    'profileAvatar.buttons.uploadNew': 'Upload new avatar',
    'profileAvatar.buttons.remove': 'Remove avatar',
    'profileAvatar.error.tooLarge': 'File is too large. Maximum file size is 5Mb.',
    'pairedDevices.title': 'Paired devices',
    'pairedDevices.subtitle': 'Headsets and tablets you signed in by entering a pairing code.',
    'pairedDevices.empty': 'You have not paired any devices.',
    'pairedDevices.unnamed': 'Unnamed device',
    'pairedDevices.meta': (platform: string, pairedAt: string, ip: string) =>
        [platform, pairedAt, ip].filter(Boolean).join(' · '),
    'pairedDevices.revoke': 'Revoke',
    'pairedDevices.revokeConfirm.message': 'Revoke this device?',
    // Deliberately specific about the delay. An access token is a signed JWT that services check
    // offline, so revoking cannot reach one that has already been handed out — it only stops the
    // renewal. Saying "signed out immediately" would be untrue.
    'pairedDevices.revokeConfirm.note':
    'It will stop working within 15 minutes and will then need a new pairing code. '
    + 'This also signs out your other WEAVR Player devices.',
}
